export const redirectorKeys = {
    REDIRECT: 'redirect',
}
